import { render, staticRenderFns } from "./ChangeLanguageButton.vue?vue&type=template&id=76b8b6da&"
import script from "./ChangeLanguageButton.vue?vue&type=script&lang=js&"
export * from "./ChangeLanguageButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76b8b6da')) {
      api.createRecord('76b8b6da', component.options)
    } else {
      api.reload('76b8b6da', component.options)
    }
    module.hot.accept("./ChangeLanguageButton.vue?vue&type=template&id=76b8b6da&", function () {
      api.rerender('76b8b6da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/local/base/ChangeLanguageButton.vue"
export default component.exports